import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=9d3915fc&scoped=true"
import script from "./Siderbar.vue?vue&type=script&lang=js"
export * from "./Siderbar.vue?vue&type=script&lang=js"
import style0 from "./Siderbar.vue?vue&type=style&index=0&id=9d3915fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3915fc",
  null
  
)

export default component.exports